import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../core";
import { LoyaltyProgramSettingsGetDto, LoyaltyProgramSettingsPostDto } from "../dto";

@Injectable({ providedIn: "root" })
export class LoyaltyProgramService {
  private serviceUrl = "LoyaltyProgram";

  constructor(private http: ApiService) {}

  getSettings(): Observable<LoyaltyProgramSettingsGetDto> {
    return this.http.get(`${this.serviceUrl}/settings`);
  }

  updateSettings(params: LoyaltyProgramSettingsPostDto): Observable<LoyaltyProgramSettingsGetDto> {
    return this.http.post(`${this.serviceUrl}/settings`, params);
  }
}
